module.exports = __webpack_public_path__ + "img/radio.a15d6073.svg";